/* eslint-disable max-len */
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { LocaleSharedModule } from '@app/i18n/locale-shared.module';
import { UserCardMiniModule } from '@app/users/user-card-mini/user-card-mini.module';
import { DatetimePickerModule } from '@core/components/datetime-picker';
import { MobileModalModule } from '@core/components/mobile-modal/mobile-modal.module';
import { ModalModule } from '@core/components/modal/modal.module';
import { SpinnersModule } from '@core/components/spinners/spinners.module';

import { AddCardWizardDialogModule } from '@shared/checkout-wizards/add-card-wizard-dialog';
import { StepByStepWizardModule } from '@shared/step-by-step-wizard';

import { DateFnsModule } from 'lingo2-ngx-date-fns';
import { ClickOutsideModule } from 'ng-click-outside';
import { OnUiButtonModule, OnUiCoverModule } from 'onclass-ui';
import { SharedModule } from '../../../vocabulary/shared.module';
import { PayButtonComponent } from '../components/pay-button/pay-button.component';
import { PaymentWidgetModule } from '../components/payment-widget';
import { SchoolHeaderDetailsComponent } from '../components/school-header-details/school-header-details.component';
import { TeacherHeaderDetailsModule } from '../components/teacher-header-details';
import { UserServiceContractFooterDetailsComponent } from '../components/user-service-contract-footer-details/user-service-contract-footer-details.component';
import { WarningOwnServiceComponent } from '../components/warning-own-service/warning-own-service.component';
import { UserServiceContractCheckoutDialogComponent } from './user-service-contract-checkout-dialog.component';

@NgModule({
  declarations: [UserServiceContractCheckoutDialogComponent],
  imports: [
    LocaleSharedModule,
    CommonModule,
    SharedModule,
    StepByStepWizardModule,
    PaymentWidgetModule,
    AddCardWizardDialogModule,
    MobileModalModule,
    ModalModule,
    UserCardMiniModule,
    OnUiCoverModule,
    SpinnersModule,
    SpinnersModule,
    DatetimePickerModule,
    SchoolHeaderDetailsComponent,
    TeacherHeaderDetailsModule,
    WarningOwnServiceComponent,
    UserServiceContractFooterDetailsComponent,
    PayButtonComponent,

    DateFnsModule,
    ClickOutsideModule,
    OnUiButtonModule,
  ],
  exports: [UserServiceContractCheckoutDialogComponent],
})
export class UserServiceContractCheckoutDialogModule {}
